import React, { useState, useEffect } from 'react';
import { Box, Typography, Button, Link } from '@mui/material';
import { motion, AnimatePresence } from 'framer-motion';
import { useLocation } from 'react-router-dom';
import Cookies from 'js-cookie';
import { isSlideUpEnabledPath } from '../constants/motionVariants';


const CookieBanner = () => {
	const [visible, setVisible] = useState(false);
	const location = useLocation();
	const slideUpEnabled = isSlideUpEnabledPath(location.pathname);

	useEffect(() => {
		const cookieAccepted = Cookies.get('cookieAccepted');
		if (!cookieAccepted) {
			setVisible(true);
		}
	}, []);

	const handleAccept = () => {
		Cookies.set('cookieAccepted', 'true', { expires: 365 });
		setVisible(false);
	};

	return (
		<AnimatePresence>
			{visible && (
				<Box
					component={motion.div}
					initial={{ y: slideUpEnabled ? 80 : 0, opacity: 0 }}
					animate={{ y: 0, opacity: 1 }}
					exit={{ y: slideUpEnabled ? 80 : 0, opacity: 0 }}
					transition={{ type: 'spring', stiffness: 300, damping: 35 }}
					sx={{
						position: 'fixed',
						bottom: 0,
						left: 0,
						right: 0,
						zIndex: 1400,
						bgcolor: 'var(--gof-color-primary)',
						borderTop: '1px solid rgba(255, 255, 255, 0.08)',
					}}
				>
					<Box
						sx={{
							maxWidth: '1200px',
							mx: 'auto',
							px: { xs: 2, sm: 4 },
							py: { xs: 2.5, sm: 2 },
							display: 'flex',
							flexDirection: { xs: 'column', sm: 'row' },
							alignItems: { xs: 'stretch', sm: 'center' },
							gap: { xs: 2, sm: 3 },
						}}
					>
						<Typography
							variant="body2"
							sx={{
								color: 'rgba(255, 255, 255, 0.75)',
								fontSize: '0.875rem',
								lineHeight: 1.6,
								flex: 1,
							}}
						>
							Мы используем файлы cookie для улучшения работы сайта. Продолжая использовать наш сайт, вы соглашаетесь с{' '}
							<Link
								href="/terms-of-service"
								sx={{
									color: '#fdb97e',
									textDecoration: 'none',
									transition: 'color 0.2s',
									'&:hover': { color: 'var(--gof-color-accent)' },
								}}
							>
								условиями использования
							</Link>
							{' '}и{' '}
							<Link
								href="/privacy-policy"
								sx={{
									color: '#fdb97e',
									textDecoration: 'none',
									transition: 'color 0.2s',
									'&:hover': { color: 'var(--gof-color-accent)' },
								}}
							>
								политикой конфиденциальности
							</Link>
							.
						</Typography>

						<Button
							variant="contained"
							onClick={handleAccept}
							sx={{
								bgcolor: 'var(--gof-color-accent)',
								color: '#fff',
								fontWeight: 600,
								fontSize: '0.9rem',
								textTransform: 'none',
								px: 3.5,
								py: 1,
								borderRadius: '10px',
								flexShrink: 0,
								alignSelf: { xs: 'flex-end', sm: 'center' },
								boxShadow: '0 2px 8px rgba(var(--gof-rgb-accent), 0.3)',
								'&:hover': {
									bgcolor: 'var(--gof-color-accent-hover)',
									boxShadow: '0 4px 16px rgba(var(--gof-rgb-accent), 0.4)',
								},
							}}
						>
							Хорошо
						</Button>
					</Box>
				</Box>
			)}
		</AnimatePresence>
	);
};

export default CookieBanner;
